import { render, staticRenderFns } from "./ListaSelecaoRequisicaoProdutos.vue?vue&type=template&id=7a9742b2&"
import script from "./ListaSelecaoRequisicaoProdutos.vue?vue&type=script&lang=js&"
export * from "./ListaSelecaoRequisicaoProdutos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports